import React from "react"
import { useAppSelector } from "../../../../../app/hooks"
import { AccountNonSurgProcList } from "./AccountNonSurgProcList";
import { Box, Stack, TextField } from "@mui/material";
import { AccountTotalNonSurgCharges } from "./AccountTotalNonSurgeCharges";
import { CalculateReimbursementBtn } from "../finalReimbursement/CalculateReimbursementBtn";
import { formatNumber } from "@progress/kendo-intl";

function NonSurgicalProcs(){
    const account = useAppSelector((state) => state.account.account);
    const totalCalcReimbursement = account.transactionHeader?.totalCalcReimbursement;

    return<React.Fragment>
        <br/>
        <Stack direction='row' marginBottom='10px' marginLeft='10px' gap={1} alignItems='center'>
            <AccountTotalNonSurgCharges/>
            <TextField 
                label='Total Calc Reimbursement' 
                value={totalCalcReimbursement !== null && totalCalcReimbursement !== undefined 
                    ? formatNumber(totalCalcReimbursement, 'c')
                    : 'Not Calculated'}
                disabled
            />
            <Box sx={{ flexGrow: 1 }} />
            <Box sx={{ marginRight: '15px' }}>
                <CalculateReimbursementBtn/>
            </Box>
        </Stack>
        <AccountNonSurgProcList/>
    </React.Fragment>
}
export {NonSurgicalProcs}